import { render } from "./docCheck.vue?vue&type=template&id=54367c62&scoped=true&ts=true"
import script from "./docCheck.vue?vue&type=script&lang=ts"
export * from "./docCheck.vue?vue&type=script&lang=ts"

import "./docCheck.vue?vue&type=style&index=0&id=54367c62&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/ws-frontend-join/ws-frontend-join/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54367c62"]])

export default __exports__